(function(app, ng) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Transaction.Application.OptionalForms",
            {
                url: "/OptionalForms",
                component: "optionalForms",
                resolve: {
                    optionalForms: [
                        "fillableFormApi", "transaction", function(fillableFormApi, transaction) {
                            return fillableFormApi.getTransactionForms(transaction.Id);
                        }
                    ]
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "OptionalForms";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
        }
    ]);

    app.component("optionalForms",
    {
        templateUrl: "/App/Transaction/Application/OptionalForms/template.html",
        controller: optionalFormsController,
        bindings: {
            transaction: "<",
            optionalForms: "<",
            transactionGroup: "<"
        }
    });

    optionalFormsController.$inject = ["$scope", "$state", "_", "transactionApi", "$mdDialog", "firelightSsoApi"];
    function optionalFormsController($scope, $state, _, transactionApi, $mdDialog, firelightSsoApi) {
        var $ctrl = this;
        $scope.$parent.$ctrl.getCurrentStage($state);

        ng.extend($ctrl,
        {
            updateCompletedForms: updateCompletedForms,
            startFirelightSso: startFirelightSso
        });

        function updateCompletedForms(optionalFormId) {
            if (_.some($ctrl.transaction.CompletedOptionalForms,
                function(completedForm) {
                    return optionalFormId === completedForm;
                }))
                _.remove($ctrl.transaction.CompletedOptionalForms,
                    function(completedForm) {
                        return completedForm === optionalFormId;
                    });
            else {
                $ctrl.transaction.CompletedOptionalForms.push(optionalFormId);
            }

            transactionApi.updateCompletedOptionalForms($ctrl.transaction.Id, $ctrl.transaction);
        };

        this.$onInit = function() {
            ng.forEach($ctrl.optionalForms,
                function (optionalForm) {
                    if (_.some($ctrl.transaction.CompletedOptionalForms,
                        function (completedForm) {
                            return optionalForm.Id === completedForm;
                        })) {
                        optionalForm.isCompleted = true;
                    }
                });
        };

        function startFirelightSso($event) {
            var leave = $mdDialog.confirm({
                title: "Are you sure you want to launch this transaction into Firelight?",
                htmlContent:
                "<p>If you choose to continue, your transaction will be compiled and you will finish this transaction in Firelight.</p> <p> Any edits to this transaction in the future will be unavailable.</p>",
                targetEvent: $event,
                ariaLabel: "Confirm submitting transaction",
                ok: "Submit",
                cancel: "Cancel",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function () {
                    var w = window.open();
                    w.document.write("Loading...");
                    return firelightSsoApi.InitiateFirelightSso($ctrl.transaction.Id).then(function (data) {
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                        $ctrl.transaction.TransactionStatus = "SubmittedToFirelight";
                        transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction);
                    }, function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
                });
        }
    }

})(window.app, window.angular); //jshint ignore:line